/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * commenttag-service.ts  2026-01-21T16:22:03+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

import type { CmtTagRuleVO } from './wy-dto'

const _ = 'CommentTag/'

export class CommentTagService {
  constructor(readonly r: RpcService) {}
  // 获取评论标签
  getTags(m?: M): R<Array<CmtTagRuleVO>> {
    return this.r.async(_ + 'getTags', undefined, m)
  }
}
